const ForcedWarning = () => (
  <svg
    width="30"
    height="30"
    viewBox="0 0 30 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M28.5669 9.125L20.8794 1.4375C20.8217 1.37867 20.753 1.33182 20.6772 1.29964C20.6013 1.26746 20.5199 1.25059 20.4375 1.25H9.5625C9.39675 1.25004 9.23781 1.31591 9.12063 1.43313L1.43313 9.125C1.31697 9.24111 1.25119 9.39827 1.25 9.5625V20.4375C1.25004 20.6032 1.31591 20.7622 1.43313 20.8794L9.12063 28.5669C9.23781 28.6841 9.39675 28.75 9.5625 28.75H20.4375C20.6032 28.75 20.7622 28.6841 20.8794 28.5669L28.5669 20.8794C28.6841 20.7622 28.75 20.6032 28.75 20.4375V9.5625C28.7488 9.39827 28.683 9.24111 28.5669 9.125Z"
      fill="#FFD764"
    />
    <path
      d="M15 23.75C14.7528 23.75 14.5111 23.6767 14.3055 23.5393C14.1 23.402 13.9398 23.2068 13.8452 22.9784C13.7505 22.75 13.7258 22.4986 13.774 22.2561C13.8223 22.0137 13.9413 21.7909 14.1161 21.6161C14.2909 21.4413 14.5137 21.3223 14.7561 21.274C14.9986 21.2258 15.2499 21.2505 15.4784 21.3452C15.7068 21.4398 15.902 21.6 16.0393 21.8055C16.1767 22.0111 16.25 22.2528 16.25 22.5C16.25 22.8315 16.1183 23.1495 15.8839 23.3839C15.6495 23.6183 15.3315 23.75 15 23.75ZM15.6531 18.8569H14.3713L13.75 5.92938H16.2769L15.6531 18.8569Z"
      fill="#444444"
    />
  </svg>
)

export default ForcedWarning
